module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Label","namespace":"Namespace","lastPing":"Last Ping","status":"Status","availability":"Availability","performance":"Performance","externalIp":"External IP Address","provider":"Provider"}}')
  delete Component.options._Ctor
}
